import React, { useState } from 'react';
import { StepContainer, StepNavigation, ChoiceButtons } from '../components';
import { StepProps, useFormContext, FormData } from '../context';

export const StepAdicional_ObjetivoLucro: React.FC<StepProps> = ({ onNext, onPrevious, isLoading }) => {
  const { data, updateField } = useFormContext();
  const [errors, setErrors] = useState<Record<string, string>>({});

  const profitGoalOptions = [
    { label: 'R$ 200,00 a R$ 500,00', value: 'R$ 200,00 a R$ 500,00' },
    { label: 'R$ 500,00 a R$ 1.000,00', value: 'R$ 500,00 a R$ 1.000,00' },
    { label: 'Acima de R$ 1.000,00', value: 'Acima de R$ 1.000,00' },
    { label: 'Acima de R$ 2.000,00', value: 'Acima de R$ 2.000,00' },
    { label: 'Acima de R$ 3.000,00', value: 'Acima de R$ 3.000,00' },
    { label: 'Acima de R$ 4.000,00', value: 'Acima de R$ 4.000,00' },
    { label: 'Acima de R$ 5.000,00', value: 'Acima de R$ 5.000,00' },
    { label: 'Acima de R$ 10.000,00', value: 'Acima de R$ 10.000,00' },
    { label: 'Acima de R$ 20.000,00', value: 'Acima de R$ 20.000,00' },
  ];

  const handleNext = () => {
    const newErrors: Record<string, string> = {};

    if (!data.profitGoal) newErrors.profitGoal = 'Objetivo de lucro é obrigatório';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onNext({ profitGoal: data.profitGoal });
  };

  const handleFieldChange = (fieldName: keyof FormData, value: string) => {
    updateField(fieldName, value);
    if (errors[fieldName]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[fieldName];
        return newErrors;
      });
    }
  };

  return (
    <StepContainer title="">
      <div className="mb-6">
        <p className="font-semibold mb-3">💰 Qual o seu objetivo de lucro (por mês) com as vendas?</p>
        
        <p className="text-muted-foreground text-sm">
          Nos diga qual é sua meta de ganho mensal com a revenda de semijoias. Isso ajuda a gente a entender melhor seu potencial e seus objetivos.
        </p>
      </div>

      <div>
        <ChoiceButtons
          options={profitGoalOptions}
          selected={data.profitGoal || ''}
          onSelect={(value) => handleFieldChange('profitGoal', value)}
        />
        {errors.profitGoal && (
          <p className="text-red-600 text-sm mt-2">{errors.profitGoal}</p>
        )}
      </div>

      <StepNavigation onPrevious={onPrevious} onNext={handleNext} isLoading={isLoading} />
    </StepContainer>
  );
};

export default StepAdicional_ObjetivoLucro;
